import { Component, OnInit } from "@angular/core";
import { AuthService } from "../auth.service";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import * as CryptoJS from "crypto-js";
import { environment } from "src/environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
@Component({
  selector: "app-otp",
  templateUrl: "./otp.component.html",
  styleUrls: ["./otp.component.css"],
})
export class OtpComponent  implements OnInit{
  signupData: any
  btnDisable = false;
  OTP: number;
  encryptedData: string;
  userInfo: any;
  isLoading = false;
  constructor(
    private signUpService: AuthService,
    private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {
     const token = localStorage.getItem("signup_first");
    
    if (localStorage.getItem(environment.localStorageKey)) {
      this.encryptedData = localStorage.getItem(environment.localStorageKey);
      this.userInfo = JSON.parse(
        CryptoJS.AES.decrypt(
          this.encryptedData,
          environment.secretkey
        ).toString(CryptoJS.enc.Utf8)
      );
      if (this.userInfo.results.subscription_type == null) {
        this.router.navigate(["/subscription"]);
      } else {
        this.router.navigate(["/"]);
      }
    } else if (token == null || token == "signup_first") {
      this.router.navigate(["/"]);
    }



  }

  ngOnInit() {
    this.signupData = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("signup_first"),
        environment.secretkey
      ).toString(CryptoJS.enc.Utf8)
    );

  }
  /**
   * This function is use for submit form
   */
  onSubmit() {
    if (this.btnDisable) {
      this.spinner.show();
      this.btnDisable = false;
      this.isLoading = true;
      // const sendData = {oTP: this.oTP,}
      this.signUpService.secondStep(this.OTP).subscribe(
        (res) => {
          if (res) {
            this.spinner.hide();
            this.isLoading = false;
            this.signUpService.UpdateArray(res.results);
            const second = res.results.verify_token;
            localStorage.setItem("signup_second", second);
            this.router.navigate(["/personal-information"]);
          }
        },
        (err) => {
          if (err) {
            this.btnDisable = true;
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error("Invalid Code", "OOPS!", {
              closeButton: true,
            });
          }

        }
      );
    }
  }
  /**
   * This function is use for resend otp
   */
  resendOTP() {
    this.signUpService.resendOTPservice(this.OTP).subscribe(
      (res) => {
        if (res) {
          this.spinner.hide();
          const encryptData = CryptoJS.AES.encrypt(
            JSON.stringify(res.results),
            environment.secretkey
          ).toString();
          localStorage.setItem("signup_first", encryptData);
          this.toastr.success(res.results.message, "Success!", {
            closeButton: true,
          });
        }
      },
      (err) => {
        if (err) {
          this.spinner.hide();
        }

      }
    );
  }

  onOtpChange(event) {
    this.btnDisable = false;
    if (event.length == 4) {
      this.btnDisable = true;
      this.OTP = event;
    }
  }
}
